import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IResultOfType, IScriptDto, IServiceStatus, IServiceStatusConfigurationUpdateDto } from "../../../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class SharePointStructureCreatorService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/sharepoint-structure-creator`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string): Observable<IServiceStatus> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<IServiceStatus>(`${baseRoute}`);
  }

  save(instanceId: string, dto: IServiceStatusConfigurationUpdateDto): Observable<any> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.put<any>(`${baseRoute}`, dto);
  }

  activate(instanceId: string): Observable<IServiceStatus> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<IServiceStatus>(`${baseRoute}/activate`, {});
  }

  deactivate(instanceId: string): Observable<IServiceStatus> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<IServiceStatus>(`${baseRoute}/deactivate`, {});
  }

  testScript(instanceId: string, script: IScriptDto): Observable<IResultOfType<string>> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<IResultOfType<string>>(`${baseRoute}/test-script`, script);
  }
}
